import { ChangeDetectionStrategy, Component, OnInit, computed, signal } from '@angular/core'
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'

import { IFilterAngularComp } from 'ag-grid-angular'
import { IFilterParams } from 'ag-grid-community'

import { FlxThemeModule } from '@flowx/angular-theme'
import { FlxCheckboxModule, FlxIconModule, FlxInputModule } from '@flowx/angular-ui-toolkit'
import { TaskManagerEnumeration } from '@flowx/core-sdk'

@Component({
  selector: 'flx-select-filter',
  imports: [
    FormsModule,
    FlxInputModule,
    FlxIconModule,
    FlxCheckboxModule,
    ReactiveFormsModule,
    FlxThemeModule,
  ],
  templateUrl: './select-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './select-filter.component.scss',
})
export class SelectFilterComponent implements IFilterAngularComp, OnInit {
  private selectedValues: Set<string> = new Set<string>()
  public params: IFilterParams & { options: TaskManagerEnumeration[] }
  public filteredValues = signal<TaskManagerEnumeration[]>([])

  checkedFilteredValues = computed(() =>
    this.filteredValues().filter((option) => this.selectedValues.has(option.value))
  )
  uncheckedFilteredValues = computed(() =>
    this.filteredValues().filter((option) => !this.selectedValues.has(option.value))
  )

  keywordForm: FormGroup<{ keyword: FormControl<string> }> = new FormGroup({
    keyword: new FormControl(''),
  })

  localeText = computed(() => this.params.api.getGridOption('localeText'))

  resetLabel = computed(() => this.localeText()?.resetFilter || 'Reset')

  searchLabel = computed(() => this.localeText()?.searchOoo || 'Search...')

  ngOnInit(): void {
    this.keywordForm.valueChanges.subscribe((value) => {
      this.filteredValues.set(
        this.params.options.filter(
          (option) =>
            option.label.toLowerCase().includes(value.keyword.toLowerCase()) ||
            this.selectedValues.has(option.value)
        )
      )
    })
  }

  agInit(params: IFilterParams & { options: TaskManagerEnumeration[] }): void {
    this.params = params
    const sortedValues = params.options.sort((a, b) => a.label.localeCompare(b.label))
    this.filteredValues.set(sortedValues)
  }

  isFilterActive(): boolean {
    return this.selectedValues.size > 0
  }

  doesFilterPass(): boolean {
    return true
  }

  getModel(): any {
    return { filter: Array.from(this.selectedValues), filterType: 'enum', type: 'in' }
  }

  setModel(model: any): void {
    this.selectedValues = new Set(model ? model.values : [])
  }

  onCheckboxChange(value: string, checked: boolean): void {
    if (checked) {
      this.selectedValues.add(value)
    } else {
      this.selectedValues.delete(value)
    }

    this.filteredValues.set(
      this.filteredValues().map((option) => {
        if (option.value === value) {
          return { ...option, checked }
        }
        return option
      })
    )

    this.params.filterChangedCallback()
  }

  isSelected(value: string): boolean {
    return this.selectedValues.has(value)
  }

  resetFilter(): void {
    this.selectedValues = new Set<string>()
    this.filteredValues.set([...this.filteredValues()])
    this.params.filterChangedCallback()
  }
}
